
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Alle Daten zeigen, dass der Aussenbereich weitaus sicherer ist als der
  Innenbereich. Das Übertragungsrisiko ist im Freien viel geringer als in
  Innenräumen, da Viren, die in die Luft freigesetzt werden, schnell in der
  Atmosphäre zerstreut werden. Das bedeutet jedoch nicht, dass es draussen zu
  100% sicher ist. Einige Ansteckungen wurden auf Gespräche im Freien
  zurückgeführt (<Link href='https://t.co/JJiD20hSgz?amp=1' mdxType="Link">hier</Link> und <Link href='https://www.medrxiv.org/content/10.1101/2020.02.28.20029272v2' mdxType="Link">hier</Link>).
    </p>
    <p>Es ist vorstellbar, dass bei einem Open Air oder in einem Sportstadion mit sehr vielen Leuten, die sehr nah beieinander stehen, ein gewisses Potenzial da ist. Bei reinen Sitzplätzen ist die Gefahr sicher kleiner, bei genügend Abstand sollte die Aerosol-Übertragung in Aussenbereichen kein Problem darstellen.
    </p>
    <p>Ein kurzer <Link icon='file pdf outline' href='https://www.medrxiv.org/content/10.1101/2020.04.04.20053058v1.full.pdf' mdxType="Link">Einkauf</Link> auf dem Markt, der Besuch im Park oder eine vorübergehende Begegnung mit einem Jogger bergen ein geringes Risiko. In einer Studie mit mehr als <Link icon='file pdf outline' href='https://www.medrxiv.org/content/10.1101/2020.04.04.20053058v1.full.pdf' mdxType="Link">7300 Fällen in China</Link> war nur einer mit der Übertragung im Freien verbunden. Wenn man die Distanzregeln im Freien einhält, ist man gut geschützt, die Viruslast wird durch die Luft verdünnt und mit dem Wind weggetragen, bei schönem Wetter helfen auch Hitze und Sonnenstrahlen, die Sars-CoV-2 zusetzen. Das Beispiel von Rauchern veranschaulicht das Prinzip: Wenn Sie sich im Freien aufhalten und andere Menschen sind ihnen so nahe, dass Sie von brennenden Zigaretten viel Rauch einatmen würden, dann ist das Risiko erhöht.
    </p>
    <p>Fast ausgeschlossen ist, dass man sich infizieren kann, wenn man draussen an jemandem vorbeigeht. Es werden für eine Ansteckung mindestens einige Minuten Exposition in virushaltiger Luft vorausgesetzt.</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;